// Generated by purs version 0.11.7
"use strict";
var Control_Applicative = require("../Control.Applicative");
var Control_Bind = require("../Control.Bind");
var Control_Category = require("../Control.Category");
var Control_Monad_Except = require("../Control.Monad.Except");
var Control_Monad_Except_Trans = require("../Control.Monad.Except.Trans");
var Control_Semigroupoid = require("../Control.Semigroupoid");
var Data_Array = require("../Data.Array");
var Data_Bifunctor = require("../Data.Bifunctor");
var Data_Either = require("../Data.Either");
var Data_Foreign = require("../Data.Foreign");
var Data_Foreign_Internal = require("../Data.Foreign.Internal");
var Data_Foreign_NullOrUndefined = require("../Data.Foreign.NullOrUndefined");
var Data_Functor = require("../Data.Functor");
var Data_Identity = require("../Data.Identity");
var Data_List_Types = require("../Data.List.Types");
var Data_Maybe = require("../Data.Maybe");
var Data_StrMap = require("../Data.StrMap");
var Data_Traversable = require("../Data.Traversable");
var Prelude = require("../Prelude");
var Decode = function (decode) {
    this.decode = decode;
};
var Encode = function (encode) {
    this.encode = encode;
};
var stringEncode = new Encode(Data_Foreign.toForeign);
var stringDecode = new Decode(Data_Foreign.readString);
var numberEncode = new Encode(Data_Foreign.toForeign);
var numberDecode = new Decode(Data_Foreign.readNumber);
var intEncode = new Encode(Data_Foreign.toForeign);
var intDecode = new Decode(Data_Foreign.readInt);
var foreignEncode = new Encode(Control_Category.id(Control_Category.categoryFn));
var foreignDecode = new Decode(Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity)));
var encode = function (dict) {
    return dict.encode;
};
var encodeNullOrUndefined = function (dictEncode) {
    return new Encode(function (v) {
        return Data_Maybe.maybe(Data_Foreign_NullOrUndefined["undefined"])(encode(dictEncode))(v);
    });
};
var strMapEncode = function (dictEncode) {
    return new Encode(function ($10) {
        return Data_Foreign.toForeign(Data_StrMap.mapWithKey(function (v) {
            return encode(dictEncode);
        })($10));
    });
};
var decode = function (dict) {
    return dict.decode;
};
var decodeNullOrUndefined = function (dictDecode) {
    return new Decode(Data_Foreign_NullOrUndefined.readNullOrUndefined(decode(dictDecode)));
};
var strMapDecode = function (dictDecode) {
    return new Decode(Control_Bind.composeKleisliFlipped(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(function ($11) {
        return Data_Traversable.sequence(Data_StrMap.traversableStrMap)(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(Data_StrMap.mapWithKey(function (v) {
            return decode(dictDecode);
        })($11));
    })(Data_Foreign_Internal.readStrMap));
};
var charEncode = new Encode(Data_Foreign.toForeign);
var charDecode = new Decode(Data_Foreign.readChar);
var booleanEncode = new Encode(Data_Foreign.toForeign);
var booleanDecode = new Decode(Data_Foreign.readBoolean);
var arrayEncode = function (dictEncode) {
    return new Encode(function ($12) {
        return Data_Foreign.toForeign(Data_Functor.map(Data_Functor.functorArray)(encode(dictEncode))($12));
    });
};
var arrayDecode = function (dictDecode) {
    return new Decode((function () {
        var readElement = function (i) {
            return function (value) {
                return Control_Monad_Except.mapExcept(Data_Bifunctor.lmap(Data_Either.bifunctorEither)(Data_Functor.map(Data_List_Types.functorNonEmptyList)(Data_Foreign.ErrorAtIndex.create(i))))(decode(dictDecode)(value));
            };
        };
        var readElements = function (arr) {
            return Data_Traversable.sequence(Data_Traversable.traversableArray)(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(Data_Array.zipWith(readElement)(Data_Array.range(0)(Data_Array.length(arr)))(arr));
        };
        return Control_Bind.composeKleisli(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Data_Foreign.readArray)(readElements);
    })());
};
module.exports = {
    decode: decode,
    encode: encode,
    Decode: Decode,
    Encode: Encode,
    foreignDecode: foreignDecode,
    stringDecode: stringDecode,
    charDecode: charDecode,
    booleanDecode: booleanDecode,
    numberDecode: numberDecode,
    intDecode: intDecode,
    arrayDecode: arrayDecode,
    strMapDecode: strMapDecode,
    foreignEncode: foreignEncode,
    stringEncode: stringEncode,
    charEncode: charEncode,
    booleanEncode: booleanEncode,
    numberEncode: numberEncode,
    intEncode: intEncode,
    arrayEncode: arrayEncode,
    decodeNullOrUndefined: decodeNullOrUndefined,
    encodeNullOrUndefined: encodeNullOrUndefined,
    strMapEncode: strMapEncode
};



//////////////////
// WEBPACK FOOTER
// ./output/Data.Foreign.Class/index.js
// module id = 175
// module chunks = 0